import { lazyView } from '../../app/lazyView.js';
import type { ViewComponent } from '../../app/Shell.js';

// Layar kelompok "panduan" → komponen (lihat features/PORTING.md). Palet pencarian global ada di search.tsx.
export const views: Record<string, ViewComponent> = {
  panduan: lazyView(() => import('./Panduan.js')),
};
